export const WHATS_NEW_VERSION = '2026.08.24';

export const WHATS_NEW_SLIDE_IDS = [
  'welcome',
  'globalSearch',
  'ordersContext',
  'editOrderWorkspace',
  'productCards',
];

export const filterWhatsNewSlides = ({
  isAdmin = false,
  hasOrderAccess = false,
} = {}) =>
  WHATS_NEW_SLIDE_IDS.filter(id => {
    if (id === 'welcome') return true;
    if (
      id === 'globalSearch' ||
      id === 'ordersContext' ||
      id === 'editOrderWorkspace' ||
      id === 'productCards'
    ) {
      return hasOrderAccess || isAdmin;
    }
    return false;
  });
